export const clearRunOnce = (): void => {
    localStorage.removeItem("run");
};

clearRunOnce();
